<button #buttn
        class="buttn"
        [type]="type"
        [ngStyle]="styles"
        (click)="onClick($event)">
  <ng-content></ng-content>
</button>
